import { Component } from 'react';
import { Col, Row } from "react-flexbox-grid";
import "./date-range.css";
import moment from 'moment';
import PropTypes from "prop-types";
import intl from 'react-intl-universal';
import DateInput from "../date-input";

class DateRange extends Component {
  constructor(props) {
    super(props);

    this.state = {
      periodoInvalido: false,
      dataDe: "",
      dataAte: "",
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.dataDe !== prevProps.dataDe) {
      this.setState({ dataDe: this.props.dataDe }, () => this.verificarPeriodoInvalido());
    }

    if (this.props.dataAte !== prevProps.dataAte) {
      this.setState({ dataAte: this.props.dataAte }, () => this.verificarPeriodoInvalido());
    }
  }

  handleDataDeChange = (date) => {
    this.setState(
      {
        dataDe: date,
      },
      () => this.verificarPeriodoInvalido()
    );
    this.props.onChangeDataDe(date);
  };

  handleDataAteChange = (date) => {
    this.setState(
      {
        dataAte: date,
      },
      () => this.verificarPeriodoInvalido()
    );
    this.props.onChangeDataAte(date);
  };

  verificarPeriodoInvalido = () => {
    const { dataDe, dataAte } = this.state;
    const periodoInvalido = dataDe && dataAte && dataDe > dataAte;
    this.setState(
      {
        periodoInvalido,
      },
      () => this.props.onRangeIsValid?.(periodoInvalido)
    );
  };

  validateMinDate = () => (this.props.noMinDate ? null : moment().format("YYYY-MM-DD"));

  validateMaxDate = () => this.props.maxDate ?? null;

  render() {
    const { dataDe, dataAte, labelDe, labelAte } = this.props;
    const { periodoInvalido } = this.state;

    return (
      <Row>
        <Col xs={6} lg={6} md={6}>
          <DateInput
            label={`${labelDe ?? intl.get("commons.dateFrom")}`}
            value={dataDe}
            onChange={this.handleDataDeChange}
            minDate={this.validateMinDate()}
            canClear
            data-testid="dateFrom"
          />
        </Col>
        <Col xs={6} lg={6} md={6}>
          <DateInput
            label={`${labelAte ?? intl.get("commons.dateTo")}`}
            value={dataAte}
            onChange={this.handleDataAteChange}
            minDate={this.validateMinDate()}
            maxDate={this.validateMaxDate()}
            canClear
            lastInput
            data-testid="dateTo"
          />
        </Col>
        {periodoInvalido && (
          <div className="range-data-mensagem">
            <span>{intl.get("commons.invalidPeriod")}</span>
          </div>
        )}
      </Row>
    );
  }
}

DateRange.propTypes = {
  dataDe: PropTypes.string,
  dataAte: PropTypes.string,
  onChangeDataDe: PropTypes.func,
  onChangeDataAte: PropTypes.func,
  onRangeIsValid: PropTypes.func,
  noMinDate: PropTypes.bool,
  labelAte: PropTypes.string,
  labelDe: PropTypes.string,
  maxDate: PropTypes.string,
};

export default DateRange;
